import { TabStack } from '@/components/TabStack';

export default function DirectoryTabLayout() {
  return <TabStack tab="directory" />;
}
